import { BCTransplantLink} from '~/components/BCTransplantLink'
import { VerificationForm } from '~/components/VerificationForm'
import { Failure } from '~/components/dialogs/verify/Failure'
import { Success } from '~/components/dialogs/verify/Success'
import { useActionData, useLoaderData, useNavigation } from 'react-router'

export { action, loader } from './index.server'

type LoaderData = {
  appVersion: string | undefined
}

export default function Index() {
  const actionData = useActionData() // undefined before form is submitted
  const { appVersion } = useLoaderData<LoaderData>()
  const navigation = useNavigation()
  const isSubmitting = navigation.state === 'submitting'

  return (
    <>
      {!isSubmitting && (
        <>
          {actionData?.success === false && <Failure />}
          {actionData?.status && <Success status={actionData.status} />}
        </>
      )}
      <div className="container mx-auto flex flex-col px-5 pt-2 md:px-20  lg:px-52 lg:pb-0">
        <div>
          <BCTransplantLink />
          <h3 className="pb-3 text-[44px] font-semibold text-primary-green">
            Donor Registry Verification
          </h3>
        </div>
        <div className="container flex-grow ">
          <VerificationForm errors={actionData?.fieldErrors} />
          <div className="float-right hidden text-slate-200">App version: {appVersion} </div>
        </div>
      </div>

      <div className="mx-auto h-40  bg-[url('/images/branded-bg.png')] bg-[length:100%-40%] bg-cover bg-no-repeat"></div>
    </>
  )
}
